<template>
  <v-container fluid>
    <v-row class="px-0 py-0 my-0">
      <v-col cols="3">
        <RangeFilter
          :end="dateEnd"
          :start="dateStart"
          @getDates="getDates"
          :excludePeriod="excludePeriod"
          :defaultPeriod="defaultPeriod"
          :setDates="true"
          :disabled="loaded"
        />
      </v-col>  
    </v-row>
    <v-card class="elevation-2 py-0 px-2 mt-4 rounded-lg">
      <v-row class="px-4 pb-0 pt-3">
        <v-col cols="10" sm="5" class="pb-0" style="padding-bottom: 20px!important">
          <v-text-field
              dense
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              outlined
          ></v-text-field>
          <v-spacer></v-spacer>
        </v-col>
        <v-btn 
          color="#3F51B5" 
          class="mt-3" 
          dark 
          depressed 
          height='40'
          max-width='40'
          min-width='40'
          @click="cleanFilters"
        >
            <v-icon>
                mdi-autorenew
            </v-icon>
        </v-btn>
      </v-row>
    </v-card>
    <v-card class="elevation-2 py-1 px-0 mt-4 rounded-lg">
      <v-row class="px-2 mt-5">
        <v-spacer></v-spacer>
          <v-col cols="7" md="6" sm="9" class="d-flex justify-end pb-0 pt-0 mt-0">
            <v-spacer></v-spacer>
            <vue-excel-xlsx
              :data="dataFilteredForExcel"
              :columns="columnsData"
              :filename="`CallRailReport`"
              :sheetname="`${createSheetName}`"
            >
              <v-btn
                height="39"
                min-width="39px"
                class="ml-auto mr-5 rounded-lg pa-0 ma-0"
                color="white"
              >
                <ExportExcel />
              </v-btn>
            </vue-excel-xlsx>
            <CustomColumns 
              :currentValue="value"
              :currentCustomHeader="customHeader"
              :currentHeaders="headers"
              :settingsName="settingsName"
              @getCustomData="getCustomData"
            />
          </v-col>
      </v-row>
      <v-hover v-model="hoverOnTable">
        <v-card-text>
          <div class="d-flex justify-space-between nav">        
            <v-btn
              class="mx-2 scroll-btn btn-left-arrow"
              fab
              small     
              @click="scrollingLeft"
            >
              <v-icon>
                mdi-arrow-left
              </v-icon>
            </v-btn>
            <v-btn
              class="mx-2 scroll-btn btn-right-arrow"
              fab
              small
              @click="scrollingRight"
            >
              <v-icon>
                mdi-arrow-right
              </v-icon>
            </v-btn>
          </div>
          <v-data-table
              v-model="selected"
              :headers="selectedHeaders"
              :items="data"
              item-key="id"
              class="elevation-0 mt-2 table-main-container"
              fixed-header
              height="538"
              :loading="loaded"
              :search="search"
              loading-text="Loading... Please wait"
              :page.sync="pagination.page"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :footer-props="{
                'items-per-page-options': [10, 25, 50, 75, 100, -1]
                }"
              @click:row="rowClick"
          >
            <template v-slot:item.recording_player="{ item }">
                <span v-if="item.recording_player != '-' ">
                  <a :href="item.recording_player" target="_blank">Open Link</a>
                </span>
                <span v-else>-</span>
            </template>
            <template v-slot:item.start_time="{ item }">
              <span>{{item.start_time | formatDateTime }}</span>
            </template>
            <template v-slot:item.customer_phone_number="{ item }">
              <span>{{item.customer_phone_number | formatPhone }}</span>
            </template>
            <template v-slot:item.tracking_phone_number="{ item }">
              <span>{{item.tracking_phone_number | formatPhone }}</span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-hover>
    </v-card>
  </v-container>
</template>

<script>
import axios from '@/api/axios-auth'
import RangeFilter from '@/components/filters/RangePicker'
import CustomColumns from '@/components/customizing/CustomColumns'
import ExportExcel from '@/components/customizing/ExportExcel'

export default {
  components: {
    RangeFilter,
    CustomColumns,
    ExportExcel
  },
  data() {
    return {
      hideAnything: false,
      selected: [],
      search: '',
      sortBy: 'start_time',
      sortDesc: true,
      headers: [
        {text: 'Id', value: 'id', class: 'black--text'},
        {text: 'Date and Time', value: 'start_time', class: 'black--text'},
        {text: 'Tracking Phone #', value: 'tracking_phone_number', class: 'black--text'},
        {text: 'Answered', value: 'answered', class: 'black--text'},
        {text: 'Duration', value: 'duration', class: 'black--text'},
        {text: 'Contact', value: 'customer_name', class: 'black--text'},
        {text: 'Contact Phone #', value: 'customer_phone_number', class: 'black--text'},
        {text: 'Country', value: 'customer_country', class: 'black--text'},
        {text: 'City', value: 'customer_city', class: 'black--text'},
        {text: 'Recording URL', value: 'recording_player', class: 'black--text'},
        {text: 'Source', value: 'source', class: 'black--text'},
        {text: 'Keyword', value: 'keywords', class: 'black--text'},
        {text: 'Campaign', value: 'campaign', class: 'black--text'},
      ],
      customHeader: ['id', 'tracking_phone_number', 'start_time',  'answered', 'source','duration', 'customer_name',
        'customer_phone_number', 'customer_country',
        'customer_city', 'recording_player', 'keywords', 'campaign'],
      selectedHeaders: [],
      value: [
        {text: 'Id', value: 'id', class: 'black--text'},
        {text: 'Date and Time', value: 'start_time', class: 'black--text'},
        {text: 'Tracking Phone #', value: 'tracking_phone_number', class: 'black--text'},
        {text: 'Answered', value: 'answered', class: 'black--text'},
        {text: 'Duration (sec)', value: 'duration', class: 'black--text'},
        {text: 'Contact', value: 'customer_name', class: 'black--text'},
        {text: 'Contact Phone #', value: 'customer_phone_number', class: 'black--text'},
        {text: 'Country', value: 'customer_country', class: 'black--text'},
        {text: 'City', value: 'customer_city', class: 'black--text'},
        {text: 'Recording URL', value: 'recording_player', class: 'black--text'},
        {text: 'Source', value: 'source', class: 'black--text'},
        {text: 'Keyword', value: 'keywords', class: 'black--text'},
        {text: 'Campaign', value: 'campaign', class: 'black--text'},
      ],
      settingsName: 'callRailReport',
      data: [],
      dataOrigin: [],
      historyChanged: [],
      dialogHistory: false,
      userName: null,
      loaded: false,
      dateEnd: new Date().toISOString().substr(0, 10),
      dateStart: new Date(
                  Date.UTC(
                    new Date().getFullYear(), 
                    new Date().getMonth(),
                    1)).toISOString().substr(0, 10),
      excludePeriod: [],
      defaultPeriod: 4,
      dialogCustomColumns: false,
      scrollLeft: 0,
      scrollWidth: 0,
      clientWidth: 0,
      hoverOnTable: false,
      pagination: {
        page: 1
      }
    }
  },
  watch: {
    value(val) {
      this.selectedHeaders = val
      this.getHeaderForExcel()
    },
    hoverOnTable(){
      this.showScrollingArrows()
    },
    data(){
      this.pagination.page = 1
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.showScrollingArrows)
  },
  mounted() {
    if (sessionStorage.getItem('dateStart')) {
      this.dateStart = sessionStorage.getItem('dateStart')
    }
    if (sessionStorage.getItem('dateEnd')) {
      this.dateEnd = sessionStorage.getItem('dateEnd')
    }
    
    axios
        .get('/username')
        .then(response => (this.userName = response.data))

      let userName = localStorage.getItem('username')
      let settings = this.settingsName
      let clientId = (localStorage.getItem('ClientId')) ? localStorage.getItem('ClientId') : 1
      if (localStorage.getItem(`${userName}.${clientId}.${settings}`)) {
      
        try {

          let valueCash = JSON.parse(localStorage.getItem(`${userName}.${clientId}.${settings}`))
          this.value = valueCash.filter(e => this.headers.find(item => item.value === e.value))
          
          const parsed = JSON.stringify(this.value)
          localStorage.setItem(`${userName}.${clientId}.${settings}`, parsed)

          this.customHeader = this.value.map(e => e.value)

          this.getHeaderForExcel()
        } catch(e) {
          console.log("")
          }
      }

    this.applyFilters()
    this.showScrollingArrows()
  },
  created() {
    this.selectedHeaders = this.value
    this.getHeaderForExcel()
    window.addEventListener("resize", this.showScrollingArrows)
  },
  computed: {
    dataFilteredForExcel(){
      let data = JSON.parse(JSON.stringify(this.data))
      return data
    },
    createSheetName(){
      let name = 'CallRail Report'
      if (name.length > 30) name = name.substr(0, 30)
      name = name.replace(/(\\|\/)/g, '-')
      return name
    }
  },
  methods: {
    scrollingRight(){
      const el = document.querySelector('.v-data-table__wrapper')

      el.scrollLeft = el.scrollLeft + 50

      const btnRight = document.querySelector('.btn-right-arrow')
      const btnLeft = document.querySelector('.btn-left-arrow')
      btnRight.style.visibility = (this.hoverOnTable && (el.scrollLeft + el.clientWidth != el.scrollWidth)) ? 'visible' : 'hidden'
      btnLeft.style.visibility = this.hoverOnTable ? 'visible' : 'hidden'
    },
    scrollingLeft(){
      const el = document.querySelector('.v-data-table__wrapper')

      el.scrollLeft = el.scrollLeft - 50

      const btnLeft = document.querySelector('.btn-left-arrow')
      const btnRight = document.querySelector('.btn-right-arrow')
      btnLeft.style.visibility = (this.hoverOnTable && (el.scrollLeft != 0)) ? 'visible' : 'hidden'
      btnRight.style.visibility = this.hoverOnTable ? 'visible' : 'hidden'
    },
    showScrollingArrows(){
      const el = document.querySelector('.v-data-table__wrapper')
      this.scrollLeft = el.scrollLeft
      this.scrollWidth = el.scrollWidth
      this.clientWidth = el.clientWidth

      const btnRight = document.querySelector('.btn-right-arrow')
      const btnLeft = document.querySelector('.btn-left-arrow')
      btnRight.style.visibility = (this.hoverOnTable && (this.scrollLeft + this.clientWidth !== this.scrollWidth)) ? 'visible' : 'hidden'
      btnLeft.style.visibility = (this.hoverOnTable && (this.scrollLeft != 0)) ? 'visible' : 'hidden'
    },
    getDates(dates) {
      this.dateStart = dates.dateStart
      this.dateEnd = dates.dateEnd
      this.pagination.page = 1
      this.applyFilters()
    },
    applyFilters() {
      this.loaded = true
      axios
        .get(`/call-rail-calls/${this.dateStart}/${this.dateEnd }`)
        .then(response => {
          this.data = response.data.data

          this.loaded = false
        })
    },
    cleanFilters(){
      this.search = ''
    },
    rowClick: function (item, row) {     
      let selectState = (row.isSelected) ? false : true
      row.select(selectState)
    },
    getCustomData({customHeader, value, selectedHeaders}){
      this.customHeader = customHeader
      this.value = value
      this.selectedHeaders = selectedHeaders

      this.getHeaderForExcel()
    },
    getHeaderForExcel(){
      this.columnsData = this.selectedHeaders.map(e => {
        const obj = {}
          if (e.value !== "actions") {
            obj.label = e.text
            obj.field = e.value
          }
          return obj
      }).filter(value => Object.keys(value).length !== 0)
    }
  }
}
</script>

<style scoped>
  .btn-right-arrow {
    right: 0px;
    top: 70px;
  }
  .btn-left-arrow {
    left: 0px;
    top: 70px;
  }
</style>